import React, { useState } from 'react';
import { Button } from 'design-system';
import { TextCollectionAnnotation } from '@scale/shared/types/response/textcollection';
import { getDefaultAnnotation } from '@scale/shared/textcollection/defaults';
import { TextCollectionField } from '@scale/shared/types/params/textcollection';
import API from '@scale/frontend-lib/dashboard-api';
import { GENERATED_PROMPT_FIELD_ID } from '@scale/shared/dolphin/DASConstants';

interface Props {
  readOnly: boolean;
  assignmentId?: string;
  currentFields: TextCollectionField[];
  currentAnnotations: Record<string, TextCollectionAnnotation>;
  setAnnotationFunctions: Record<string, (annotation: TextCollectionAnnotation) => void>;
}

const GeneratePromptButton: React.FC<Props> = props => {
  const { readOnly, currentFields, setAnnotationFunctions } = props;

  const [loading, setLoading] = useState(false);
  const [hasRun, setHasRun] = useState(false);

  const generatedPromptField = currentFields.find(
    field => field.field_id === GENERATED_PROMPT_FIELD_ID,
  );

  if (!generatedPromptField) {
    throw new Error(
      'Cannot find generated prompt field in current field. Make sure there is a field that is named generated_prompt',
    );
  }

  const setPromptFn = setAnnotationFunctions[GENERATED_PROMPT_FIELD_ID];
  const canGenerate = !readOnly && !loading && !hasRun;

  const handleGenerate = async () => {
    setLoading(true);

    const response = await API.selfserve.dolphinGeneratePrompt();
    setHasRun(true);

    const annotationsA = getDefaultAnnotation(generatedPromptField);

    annotationsA.response[0] = response.prompt;

    setPromptFn(annotationsA);

    setLoading(false);
  };

  return (
    <div style={{ margin: '8px' }}>
      <Button disabled={!canGenerate} type="primary" onClick={handleGenerate}>
        Generate Prompt
      </Button>
    </div>
  );
};

export default GeneratePromptButton;
